module.exports = __webpack_public_path__ + "static/media/class_job_004.0c067f2e.svg";